// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";

export const XngPopulateApiParameter: any = (props: any) => {
    // XNG-Change:add time for get cart by id
    if (props.parameter.sendTimestamp) {
        const timestamp = `time${new Date().getTime()}`;
        props.apiParameter.expand?.push(timestamp as any);
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
